import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  selectJob,
  fetchPostsIfNeeded,
	invalidateJob,
	publishJob
} from '../actions'
import Picker from '../components/Picker'
import Posts from '../components/Posts'
import PopupPost from '../components/PopupPost'
import AddJob from '../components/AddJob'
import AdSense from 'react-adsense'
import logoIcon from '../img/camel.png'
import firebase from 'firebase'

class AsyncApp extends Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleRefreshClick = this.handleRefreshClick.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.state = {
			popupPostId: 0,
			tag: 'All',
			searchText: '',
			opened: false,
			keyword: this.props.location.pathname.slice(1, this.props.location.pathname.length),
			filteredPosts: [],
			bottomBarClosed: false,
			localPosts: [],
			jobOptions: ["All", "java", ".net", "c#", "customer support", "mysql", "css", "api", "senior", "intern", "sql", "consultant", "go", "teacher", "data entry", "react", "marketing", "node", "angular", "vue", "javascript", "Customer Service", "sales", "manager", "blockchain", "medical", "analyst", "designer", "seo", "writer", "quality assurance", "devops", "support engineer", "full stack", "machine learning"]
    };
	}

	componentWillMount () {
		const script = document.createElement("script");
		script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
		script.async = true;
		document.body.appendChild(script);
		const { updateLocalState } = this;
		// this.databaseRef.on('child_added', snapshot => {
		// 	const response = snapshot.val();
		// 	updateLocalState(response);
		// });
		// this.databaseRef.once('value').then(snapshot => {
		// 	const response2 = snapshot.val();
		// 	const values = Object.keys(response2).map(function(e) {
		// 		return response2[e];
		// 	});
		// 	const filtered = this.state.filteredPosts;
		// 	filtered.push(values)
		// 	this.setState({ localPosts: filtered })
		// })
	}
	
  componentDidMount() {
		const { dispatch, selectedJob } = this.props;
		const { keyword, jobOptions } = this.state;
		let humanKeyword = keyword.split('-').join(" ");
		if (keyword !== '' && jobOptions.includes(humanKeyword)) {
			let documentTitle = `Remote ${humanKeyword} jobs - Remote Ted`;
			this.setState({
				tag: humanKeyword
			});
			this.props.dispatch(selectJob(this.state.tag))
			this.props.dispatch(fetchPostsIfNeeded(this.state.tag, this.state.searchText, this.state.keyword))
			document.title = documentTitle.charAt(0).toUpperCase() + documentTitle.slice(1);
		} else {
			dispatch(fetchPostsIfNeeded(selectedJob, this.state.searchText, this.state.keyword))
		}
	}

  componentDidUpdate(prevProps) {
    if (this.props.selectedJob !== prevProps.selectedJob) {
      const { dispatch, selectedJob } = this.props
			dispatch(fetchPostsIfNeeded(selectedJob, this.state.searchText, this.state.keyword),
			this.setState({
				originalPosts: this.props.posts
			}))
    }
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			filteredPosts: nextProps.posts
		});
	}

	updateLocalState = (response) => {
		const current = this.state.localPosts;
		current.push(response);
		current.push(this.state.filteredPosts);
		this.setState({
			localPosts: current
		});
	}

	// addPost = () => {
	// 	const postToSave = {title: this.title.value,
	// 		company: this.company.value,
	// 		description: this.description.value,
	// 		url: this.url.value,
	// 		created_at: Date(),
	// 		sponsored: true
	// 	};
	// 	this.databaseRef.push().set(postToSave);
	// }
	
	debounce = (func, wait, immediate) => {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

  handleChange(nextJob) {
		this.setState({
			tag: nextJob
		});
    this.props.dispatch(selectJob(nextJob))
    this.props.dispatch(fetchPostsIfNeeded(nextJob, this.state.searchText, this.state.keyword))
	}
	
	handleSearchChange = this.debounce((props, e) => {
		const searchTextLowered = e.toLowerCase();
		if (e.length > 2 || this.state.searchText.length > 0) {
			let filteredPosts = props.posts.filter((job) => {
				if (job.title) {
					if (!job.description) {
						return job.title.toLowerCase().includes(searchTextLowered)
					} else {
						return job.description.toLowerCase().includes(searchTextLowered);
					}
				} else if (job.position) {
					if (!job.description) {
						return job.position.toLowerCase().includes(searchTextLowered)
					} else {
						return job.description.toLowerCase().includes(searchTextLowered);
					}
				}
				return '';
			})
			this.setState({
				filteredPosts,
				searchText: e
			});
			// this.setState({
			// }, () => {
			// 	// this.props.dispatch(fetchPostsIfNeeded(this.props.selectedJob, this.state.searchText));
			// }
			// );
		}
	}, 600)

	handleClose = (opened) => {
		this.setState({
			opened
		})
	}

	handleBottomBar = () => {
		this.setState({
			bottomBarClosed: true
		})
	}

  handleClick(url) {
    this.setState({
      popupPostId: url,
      opened: true
    });
    
	}
	
	addJob = () => {
    this.setState({
			opened: true,
			popupPostId: null
    });
  }

  handlePopupClose() {
    this.setState({
			popupPostId: null,
			opened: false
    })
  }

  handleRefreshClick(e) {
    e.preventDefault()

    const { dispatch, selectedJob } = this.props
    dispatch(invalidateJob(selectedJob))
    dispatch(fetchPostsIfNeeded(selectedJob, this.state.searchText, this.state.keyword))
  }

  render() {
		const { selectedJob, posts, isFetching, lastUpdated } = this.props
		const { popupPostId, filteredPosts, bottomBarClosed, keyword, tag, jobOptions } = this.state
    return (
      <div>
        <header>
					{/* <img title="Remote Ted - Remote jobs for digital nomads" src={logoIcon} alt="Remote Ted - Remote jobs for digital nomads"
					className="website-logo" /> */}
					<h1>Remote {(tag && tag !== "All") && tag + " "}jobs</h1>
					<Picker
						value={selectedJob}
						onChange={this.handleChange}
						onSearchChange={(e) => this.handleSearchChange(this.props, e)}
						searchKeyword={keyword}
						options={jobOptions}
					>
						{/* { !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
				<AdSense.Google client='ca-pub-2644184637828327'
				slot='9315249875' style={{ width: '730px', position: 'absolute', right: '20px', top: '10px'}} />} */}
					</Picker>
				<div className="button add-job" onClick={this.addJob}>Post a Job FOR FREE!</div>
				<AddJob dispatch={this.props.dispatch} onClick={this.handleClose} opened={this.state.opened}/>
        </header>
				<div className="container">
					<p className="time-updated">
					<span className="jobs-count">Jobs found: <strong>{filteredPosts.length}</strong></span>
						{lastUpdated &&
							<span className="last-updated">
								Last updated at {new Date(lastUpdated).toLocaleTimeString()}.
								{' '}
							</span>}
						{/* {!isFetching &&
							<span className="refresh" onClick={this.handleRefreshClick}> Refresh</span>} */}
					</p>
					{(isFetching || posts.length === 0) && <h2>Loading...</h2>}
					{(!isFetching && posts.length === 0) && <h2>Empty.</h2>}
					{posts.length > 0 &&
					<div style={{ opacity: isFetching ? 0.5 : 1 }}>
						<Posts posts={filteredPosts} onClick={this.handleClick}/>
					</div>}
					{posts.filter(post => post.id === popupPostId)[0] !== undefined &&
						<PopupPost onClick={this.handleClose} post={posts.filter(post => post.id === popupPostId)[0]} opened={this.state.opened}>
							<AdSense.Google client='ca-pub-2644184637828327' slot='9931516914' />
						</PopupPost>
					}
				</div>
					<div className={bottomBarClosed ? "bottom-bar closed" : "bottom-bar"}>
					<h3>Subscribe to get latest remote jobs in your email</h3>
						<div id="mc_embed_signup">
							<form action="https://itopen.us3.list-manage.com/subscribe/post?u=a3ab4b6c8a8ace4e1f041250a&amp;id=588fe4f9bf" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
								<div id="mc_embed_signup_scroll">
									<div className="mc-field-group">
										<input type="email" name="EMAIL" className="required email" placeholder="Email" id="mce-EMAIL"/>
									</div>
									<input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button"/>
									<div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true"><input type="text" name="b_a3ab4b6c8a8ace4e1f041250a_588fe4f9bf" tabIndex="-1" value=""/></div>
									<div id="mce-responses" className="clear">
										<div className="response" id="mce-error-response" style={{display: 'none'}}></div>
										<div className="response" id="mce-success-response" style={{display: 'none'}}></div>
									</div>
								</div>
							</form>
						</div>
						<img onClick={this.handleBottomBar} className="close" alt="Remote Ted logo" src="data:image/png;base64,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" />
					</div>
      </div>
    )
  }
}

AsyncApp.propTypes = {
  selectedJob: PropTypes.string.isRequired,
  posts: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  lastUpdated: PropTypes.number,
	dispatch: PropTypes.func.isRequired,
	keyword: PropTypes.string
}

function mapStateToProps(state, ownProps) {
  const { selectedJob, postsByJob, tag } = state
  const {
    isFetching,
    lastUpdated,
    items: posts
  } = postsByJob[tag || selectedJob] || {
    isFetching: true,
    items: [],
  }

	return {
		selectedJob,
		posts,
		isFetching,
		lastUpdated
	}
}

export default connect(mapStateToProps)(AsyncApp)


// WEBPACK FOOTER //
// ./src/containers/AsyncApp.js